import React from 'react';
import { Palette, Globe, Share2, Search, Mail, Workflow, Server, ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../data/siteData';
import useReveal from '../hooks/useReveal';

const ICONS = { Palette, Globe, Share2, Search, Mail, Workflow, Server };

function ServiceCard({ service, index }) {
  const ref = useReveal();
  const Icon = ICONS[service.icon];

  const goContact = () => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <article
      ref={ref}
      className={`service-card reveal ${service.big ? 'service-card-big' : ''}`}
      style={{ transitionDelay: `${(index % 4) * 80}ms` }}
      data-testid={`service-card-${service.id}`}
    >
      <div className="service-card-top">
        <div className="service-icon"><Icon size={22} /></div>
        <span className="service-code">{service.code}</span>
      </div>
      <h3 className="service-title">{service.title}</h3>
      <p className="service-tagline">{service.tagline}</p>
      <p className="service-desc">{service.description}</p>
      <div className="service-chips">
        {service.items.map((item) => (
          <span key={item} className="service-chip">{item}</span>
        ))}
      </div>
      <button className="service-link" onClick={goContact} data-testid={`service-link-${service.id}`}>
        Start this mission <ArrowUpRight size={15} />
      </button>
    </article>
  );
}

export default function Services() {
  const headRef = useReveal();

  return (
    <section className="section services-section" id="services" data-testid="services-section">
      <div className="section-inner">
        <div className="section-head reveal" ref={headRef}>
          <span className="section-eyebrow">// MISSION CAPABILITIES</span>
          <h2 className="section-title">
            PICK YOUR <span className="text-pink">MISSION</span>
          </h2>
          <p className="section-sub">
            Seven specialities. One crew. Everything your brand needs to reach escape velocity.
          </p>
        </div>

        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
